import { ReactNode, useMemo, useRef, useState } from 'react'
import { NavigationDirection, navigationDirectionContext } from './index'
import { useLocation } from 'react-router-dom'

const NavigationDirectionProvider = ({ children }: { children: ReactNode }) => {
  const knownRouteKeys = useRef<Set<string>>()
  if (knownRouteKeys.current == null) {
    knownRouteKeys.current = new Set()
  }

  const location = useLocation()
  const [prevLocation, setPrevLocation] = useState<string | null>(null)
  const [prevLocations, setPrevLocations] = useState<Set<string>>(new Set())

  const [navigationDirection, setNavigationDirection] = useState(
    NavigationDirection.initial,
  )

  // inline setState to force abort rendering before effect runs
  if (prevLocation !== location.key) {
    setPrevLocation(location.key)
    setPrevLocations(new Set([...prevLocations, location.key]))

    if (prevLocations.size === 0) {
      setNavigationDirection(NavigationDirection.initial)
    } else if (prevLocations.has(location.key)) {
      setNavigationDirection(NavigationDirection.prev)
    } else {
      setNavigationDirection(NavigationDirection.navigate)
    }
  }

  const value = useMemo(
    () => ({
      direction: navigationDirection,
    }),
    [navigationDirection],
  )

  return (
    <navigationDirectionContext.Provider value={value}>
      {children}
    </navigationDirectionContext.Provider>
  )
}

export default NavigationDirectionProvider
